module.exports = __webpack_public_path__ + "img/dec22_2.65b17c33.jpg";